module.exports = __webpack_public_path__ + "img/highTech_solution_bg.ed3c73ed.png";